  /*=========================================================================================
  File Name: mutations.js
  Description: Favorite Items State Module
  ----------------------------------------------------------------------------------------
  Item Name: Fuji Sushi App
  Author: Tan Tran
==========================================================================================*/
import localStorage from '../../../storage/favorites.js'
export default {
  ADD_ITEM_TO_FAVOURITE_STATE (state, payload) {
    state.favouriteItems.push(payload.itemId);
    localStorage.storeFavouriteItemsByRestaurantId(payload.restaurantId, state.favouriteItems);
  },

  REMOVE_ITEM_FROM_FAVOURITE_STATE (state, payload) {
    let index = state.favouriteItems.findIndex(i => { return i === payload.itemId });
    if (index > -1) {
      console.log('item is removed!!!')
      state.favouriteItems.splice(index, 1);
      localStorage.storeFavouriteItemsByRestaurantId(payload.restaurantId, state.favouriteItems);
    }
  },

  LOAD_FAVOURITE_ITEMS_TO_STATE(state, payload) {
    state.favouriteItems = localStorage.getFavouriteItemsByRestaurantId(payload.restaurantId);
  }
}
